module.exports = "../images/cabin-hero-v2.jpg?v=29b474d";